import { render, staticRenderFns } from "./ChartOfAccounts.vue?vue&type=template&id=d011ff58&"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=js&"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports